import {isPublicationGroup} from 'utilities/URL';

export const getBaseURL = (
  cardId,
  pageId,
  domoappId,
  domoappsDomain,
  isPublic
) => {
  let prefix = '//';
  if (pageId && isPublicationGroup(pageId)) {
    prefix = `//${pageId.replace(/:/g, '-')}--`;
  } else if (cardId && isPublicationGroup(cardId)) {
    const split = cardId.split(':');
    //ex: ss-1269-621200813-- get page resource info from saasaas urn
    prefix = `//${split[0]}-${split[1]}-${split[2]}--`;
  }

  if (isPublic) {
    return `/cards/${cardId}/domoapps/${domoappId}`;
  } else {
    return `${prefix}${domoappId}.${domoappsDomain}`;
  }
};
